import api from "./api";
import type {
  Survey,
  CreateSurveyInput,
  Question,
  Option,
} from "@clawplete/shared/types";

export interface SurveyListResponse {
  surveys: Array<
    Survey & {
      is_owner: boolean;
    }
  >;
}

export interface SurveyDetailResponse {
  survey: Survey & {
    questions: Array<Question & { options: Option[] }>;
    is_owner: boolean;
  };
}

export const surveysService = {
  async list(params?: { status?: string; limit?: number; offset?: number; exclude_responded?: string }) {
    const response = await api.get<{ success: boolean; data: SurveyListResponse }>("/surveys", { params });
    return response.data.data;
  },

  async get(id: string) {
    const response = await api.get<{ success: boolean; data: SurveyDetailResponse }>(`/surveys/${id}`);
    return response.data.data;
  },

  async create(data: CreateSurveyInput) {
    const response = await api.post<{ success: boolean; data: { survey: Survey } }>("/surveys", data);
    return response.data.data;
  },

  async update(id: string, data: Partial<CreateSurveyInput>) {
    const response = await api.patch<{ success: boolean; data: { survey: Survey } }>(`/surveys/${id}`, data);
    return response.data.data;
  },

  async delete(id: string) {
    const response = await api.delete<{ success: boolean; data: unknown }>(`/surveys/${id}`);
    return response.data.data;
  },

  async fund(id: string) {
    const response = await api.post<{ success: boolean; data: { survey: Survey; transaction: unknown } }>(`/surveys/${id}/fund`, {});
    return response.data.data;
  },

  async activate(id: string) {
    const response = await api.post<{ success: boolean; data: { survey: Survey } }>(`/surveys/${id}/activate`, {});
    return response.data.data;
  },

  async cancel(id: string) {
    const response = await api.post<{ success: boolean; data: { survey: Survey; transaction: unknown } }>(`/surveys/${id}/cancel`, {});
    return response.data.data;
  },

  async getAnalytics(id: string) {
    const response = await api.get<{ success: boolean; data: { survey: unknown; questions: unknown[]; participations: unknown; responses_by_date: unknown[] } }>(`/surveys/${id}/analytics`);
    return response.data.data;
  },

  async export(id: string) {
    const response = await api.get(`/surveys/${id}/export`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
